import { useEffect } from 'react';

/**
 * The table library reads the saved visible columns once, when the table first sets up.
 * A gated column can arrive later (LaunchDarkly re-identifies with the selected property
 * after the first render), and useNewColumnsVisibleByDefault then saves it as visible, but
 * the library would only show it on the next visit. This adds it to the live selection too.
 */
const useShowLateColumns = ({
  headers,
  initialSelectedColumns,
  selectedColumns,
  handleColumnChange,
}: {
  headers: Array<{ id: string }>,
  initialSelectedColumns: ?Array<string>,
  selectedColumns: Array<string>,
  handleColumnChange: Function,
}) => {
  useEffect(() => {
    // Before the table sets up, selectedColumns is empty and the library applies the saved
    // list itself.
    if (!initialSelectedColumns?.length || !selectedColumns.length) return;

    const headerIds = headers.map(({ id }) => id);
    const lateIds = initialSelectedColumns.filter(
      (id) => headerIds.includes(id) && !selectedColumns.includes(id),
    );
    if (lateIds.length) {
      handleColumnChange([...selectedColumns, ...lateIds], false);
    }
    // Runs only when a new set of columns to show is computed, not on every selection change,
    // so a column the user hides afterwards stays hidden.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSelectedColumns]);
};

export default useShowLateColumns;
